import {
	BaseModal,
	ModalCloseCross,
	type BaseModalProps,
} from "@/components/ui/BaseModal";
import { Button } from "@/components/ui/button";

interface ModalConfirmarProps extends BaseModalProps {
	readonly title: string;
	readonly message: string;
	readonly onConfirm: () => void;
	readonly confirmText?: string;
	readonly cancelText?: string;
}
export function ConfirmDialog(props: ModalConfirmarProps) {
	return (
		<BaseModal shown={props.shown} close={props.close} dialogSize="sm">
			<div className="modal-header">
				<h5 className="modal-title">{props.title}</h5>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<p>{props.message}</p>
			</div>
			<div className="modal-footer">
				<Button variant="secondary" onClick={props.close}>
					{props.cancelText ?? "Cancelar"}
				</Button>
				<Button variant="primary" onClick={props.onConfirm}>
					{props.confirmText ?? "Confirmar"}
				</Button>
			</div>
		</BaseModal>
	);
}
